if (!customElements.get("fric-post-it-addon")) {
  customElements.define(
    "fric-post-it-addon",
    class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.productId = Number(this.dataset.productId);
        this.variantId = Number(this.dataset.variantId);
        this.vendor = this.dataset.vendor;
        this.quantityInput = this.querySelector("[data-post-it-quantity]");
        this.decrementButton = this.querySelector("[data-post-it-decrement]");
        this.incrementButton = this.querySelector("[data-post-it-increment]");
        this.submitButton = this.querySelector("[data-post-it-submit]");
        this.offerText = this.querySelector("[data-post-it-offer]");
        this.errorText = this.querySelector("[data-post-it-error]");
        this.submitButton.addEventListener("click", () => this.submit());
        this.decrementButton.addEventListener("click", () => {
          this.setQuantity(Number(this.quantityInput.value) - 1);
        });
        this.incrementButton.addEventListener("click", () => {
          this.setQuantity(Number(this.quantityInput.value) + 1);
        });
        this.quantityInput.addEventListener("input", () => {
          this.setQuantity(this.quantityInput.value);
        });
        this.cartEvents = [
          "shapes:cart:afteradditem",
          "shapes:cart:cartqtychange",
          "shapes:cart:update"
        ];
        this.cartEvents.forEach((eventName) => {
          window.addEventListener(eventName, () => this.sync());
        });
        this.sync();
      }

      setQuantity(value) {
        const quantity = Math.max(1, Math.min(7, Number(value) || 1));
        this.quantityInput.value = String(quantity);
        this.decrementButton.disabled = quantity <= 1;
        this.incrementButton.disabled = quantity >= 7;
      }

      async getCart() {
        const response = await fetch(window.theme.routes.cart_url, {
          credentials: "same-origin",
          headers: { Accept: "application/json" }
        });
        if (!response.ok) throw new Error("Unable to load the cart.");
        return response.json();
      }

      getState(cart) {
        const postItItem = cart.items.find(
          (item) => Number(item.product_id) === this.productId
        );
        const eligible = cart.items.some(
          (item) =>
            Number(item.product_id) !== this.productId &&
            item.vendor === this.vendor
        );
        const eligibleSubtotal = cart.items.reduce((subtotal, item) => {
          if (
            Number(item.product_id) !== this.productId &&
            item.vendor === this.vendor
          ) {
            return subtotal + item.final_line_price;
          }
          return subtotal;
        }, 0);
        return { postItItem, eligible, eligibleSubtotal };
      }

      render(cart) {
        const { postItItem, eligible, eligibleSubtotal } = this.getState(cart);
        this.hidden = !eligible;
        this.dataset.lineKey = postItItem ? postItItem.key : "";
        this.dataset.quantity = postItItem ? postItItem.quantity : 0;
        this.setQuantity(postItItem ? postItItem.quantity : 1);
        this.offerText.textContent =
          eligibleSubtotal >= 12000
            ? "1 free at checkout · additional pads $12"
            : "Add one for $12";
        this.submitButton.querySelector("span").textContent = postItItem
          ? "Update quantity"
          : "Add to cart";
      }

      async sync() {
        if (this.updating || this.removingOrphan) return;
        try {
          const cart = await this.getCart();
          const { postItItem, eligible } = this.getState(cart);
          if (postItItem && !eligible) {
            await this.removeOrphan(postItItem, cart);
            return;
          }
          this.render(cart);
        } catch (error) {
          this.showError(error.message);
        }
      }

      async removeOrphan(postItItem, cart) {
        this.removingOrphan = true;
        try {
          const response = await this.change(postItItem.key, 0);
          document.body.dispatchEvent(
            new CustomEvent("shapes:cart:cartqtychange", {
              bubbles: true,
              detail: {
                response,
                key: postItItem.key,
                quantity: 0,
                previousQuantity: postItItem.quantity,
                variantId: this.variantId,
                originalTarget: this
              }
            })
          );
          this.render(response);
        } finally {
          this.removingOrphan = false;
        }
      }

      async change(key, quantity) {
        const response = await fetch(window.theme.routes.cart_change_url, {
          method: "POST",
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            "X-Requested-With": "XMLHttpRequest"
          },
          body: JSON.stringify({
            id: key,
            quantity,
            sections: "cart-items,cart-footer,cart-item-count,cart-live-region",
            sections_url: window.location.pathname
          })
        });
        const data = await response.json();
        if (!response.ok || data.status) {
          throw new Error(data.description || data.message || "Unable to update the cart.");
        }
        return data;
      }

      async submit() {
        if (this.updating) return;
        this.updating = true;
        this.submitButton.disabled = true;
        this.errorText.classList.add("hidden");
        const quantity = Math.max(
          1,
          Math.min(7, Number(this.quantityInput.value) || 1)
        );
        const previousQuantity = Number(this.dataset.quantity) || 0;
        try {
          if (this.dataset.lineKey) {
            const data = await this.change(this.dataset.lineKey, quantity);
            document.body.dispatchEvent(
              new CustomEvent("shapes:cart:cartqtychange", {
                bubbles: true,
                detail: {
                  response: data,
                  key: this.dataset.lineKey,
                  quantity,
                  previousQuantity,
                  variantId: this.variantId,
                  originalTarget: this
                }
              })
            );
            this.render(data);
          } else {
            const response = await fetch(
              `${window.Shopify.routes.root}cart/add.js`,
              {
              method: "POST",
              credentials: "same-origin",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                "X-Requested-With": "XMLHttpRequest"
              },
                body: JSON.stringify({
                  id: this.variantId,
                  quantity,
                  sections: "cart-items,cart-footer,cart-item-count,cart-live-region",
                  sections_url: window.location.pathname
                })
              }
            );
            const data = await response.json();
            if (!response.ok || data.status) {
              throw new Error(
                data.description || data.message || "Unable to add the Post-It Pad."
              );
            }
            document.body.dispatchEvent(
              new CustomEvent("shapes:cart:afteradditem", {
                bubbles: true,
                detail: { response: data, sourceId: "FricPostItQuantity" }
              })
            );
            const cart = await this.getCart();
            this.render(cart);
          }
        } catch (error) {
          this.showError(error.message);
        } finally {
          this.updating = false;
          this.submitButton.disabled = false;
        }
      }

      showError(message) {
        this.errorText.textContent = message;
        this.errorText.classList.remove("hidden");
      }
    }
  );
}
